<template>
	<div class="news" id="home">
		<div class="section">
			<div class="popclass">
				<div><p>Affrettati! Sono rimasti pochi posti disponibili per le nostre small class!</p></div>	
			</div>
			<Slideshow :num-slides="numSlides" :ratio="ratio" hide-controls>
				<SimpleSlide v-for="i in numSlides" :key="i" :background="require(`@/assets/Palestra_home${i}.jpg`)"/>
			</Slideshow>
		</div>
	</div>
</template>

<script>
export default {
	name: 'news',

	data() {

		return {
			// Number of slides
			numSlides: 4,

			/// Image ratio
			ratio: 2.5
		}
	},

	methods: {
		/**
		 *
		 */
		onResize() {

			if (window.innerWidth < 640)
				this.ratio = 1.4
			else
				this.ratio = 2.5
		}
	},

	created() {

		window.addEventListener('resize', this.onResize)
		this.onResize()
	},

	destroyed() {

		window.removeEventListener('resize', this.onResize)
	}
}
</script>

<style lang="stylus" scoped>
.section
	margin-top 0 !important

.popclass
	display none
</style>